import React from 'react';
import reservationsModel from '../../../../model/reservations';
import withRouter from '/src/components/misc/withRouter';

class ReservationComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reservation: null,
      reservationId: props.match.params.reservationId,
      hasResponse: false,
      responseObj: null,
      waitingForAjax: false,
      resendId: null
    };
  }

  UNSAFE_componentWillMount() { // eslint-disable-line camelcase
    this.fetchReservation();
  }

  componentDidUpdate() {
    const propReservationId = parseInt(this.props.match.params.reservationId, 10);
    if (this.state.reservation && this.state.reservation.id !== propReservationId) {
      this.setState({
        reservation: null,
        reservationId: propReservationId,
        hasResponse: false,
        responseObj: null,
        waitingForAjax: false,
        resendId: null
      }, () => {
        this.fetchReservation();
      });
      return;
    }
  }

  fetchReservation() {
    reservationsModel.getById(this.props.match.params.reservationId).then((reservation) => {
      document.title = `Admin - Reservasjon - ${reservation.make} - ${reservation.id}`;
      this.setState({
        reservation
      });
    }).catch((error) => {
      console.error(error);
    });
  }

  render() {
    if (!this.state.reservation) {
      return (
        <h1>404</h1>
      );
    }

    const reservation = this.state.reservation;
    const dateString = (new Date(reservation.created * 1000)).toLocaleString('nb-no');

    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <h1 className="page-header">Reservasjon</h1>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <section className="panel panel-default">
              <div className="panel-heading">
                <strong><i className="fa fa-tag"/> {reservation.description} (# {reservation.queue})</strong>
              </div>

              <div className="panel-body">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <section className="panel panel-default panel-info">
                      <div className="panel-heading" role="tab" id="heading-details">
                        <strong><i className="fa fa-user"/> Kunde</strong>
                      </div>
                      <div className="panel-body">
                        <div className="form-group">
                          <label>Navn</label>
                          <input type="text" className="form-control" value={reservation.name} disabled />
                        </div>
                        <div className="form-group">
                          <label>Adresse</label>
                          <input type="text" className="form-control" value={reservation.address} disabled />
                        </div>
                        <div className="form-group">
                          <label>Postnummer</label>
                          <input type="text" className="form-control" value={reservation.zipcode} disabled />
                        </div>
                        <div className="form-group">
                          <label>Poststed</label>
                          <input type="text" className="form-control" value={reservation.ziparea} disabled />
                        </div>
                        <div className="form-group">
                          <label>Epost</label>
                          <input type="text" className="form-control" value={reservation.email} disabled />
                        </div>
                        <div className="form-group">
                          <label>Telefon</label>
                          <input type="text" className="form-control" value={reservation.phone} disabled />
                        </div>
                      </div>
                    </section>
                  </div>
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Opprettet</label>
                      <input type="text" className="form-control" value={dateString} disabled />
                    </div>
                    <div className="form-group">
                      <label>Konto</label>
                      <input type="text" className="form-control" value={reservation.make} disabled />
                    </div>
                    <div className="form-group">
                      <label>Forhandler</label>
                      <input type="text" className="form-control" value={reservation.dealerName} disabled />
                    </div>
                    <div className="form-group">
                      <label>Beløp</label>
                      <input type="text" className="form-control" value={Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(reservation.amount / 100)} disabled />
                    </div>
                  </div>
                </div>
              </div>

              {/*
                            <div className="panel-body">
                              <div className="row">
                                <div className="col-xs-12 col-md-6">
                                  <div className="form-group">
                                    <label>Kilde</label>
                                    <textarea rows="10" className="form-control" readOnly value={JSON.stringify(reservation.data, null, 4)}></textarea>
                                    <p className="help-block">Data mottatt fra Stripe.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
              */}
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ReservationComponent);
